export default __webpack_public_path__ + "static/media/011-chameleon.cd04ceb0.svg";